const getStripeUrl = (token, email, plan, interval) =>
  `https://clearsenseinabox.com/stripe_subscriptions/new?token=${token}&email=${email}&plan=${plan}&interval=${interval}`;

export const TAB_STATES = {
  SELF_SERVE: "SELF_SERVE",
  MANAGED: "MANAGED",
};

export const FEATURE_LIST = {
  selfServe: [
    "Clearsense Data Ingestion & Lakehouse",
    "Clearsense LakeHouse Data Management",
    " Master Data Management",
    "Data Consumption",
    "Support",
  ],
  managedServices: [
    "Completely Managed Service",
    "Premium Priority Support",
    "Deployable On-Premise",
    "Whitelabeling",
  ],
};

export const TIERS = [
  {
    name: "Free",
    href: () => "#",
    interval: "month",
  },
  {
    name: "Standard",
    href: (token, email, plan, interval) =>
      getStripeUrl(token, email, plan, interval),
    interval: "month",
  },
  {
    name: "Enterprise",
    href: (token, email, plan, interval) =>
      getStripeUrl(token, email, plan, interval),
    interval: "month",
  },
  {
    name: "Complete Managed Service",
    href: (token, email, plan, interval) =>
      getStripeUrl(token, email, plan, interval),
    interval: "month",
  },
  {
    name: "Clearsense in a Box",
    href: (token, email, plan, interval) =>
      getStripeUrl(token, email, plan, interval),
    interval: "month",
  },
];

export const SECTIONS = [
  {
    id: 1,
    features: [
      {
        name: "Clearsense Data Ingestion & Lakehouse",
        priceInfo: true,
        tiers: {
          priceInfo: true,
          Free: false,
          Standard: "$50K",
          Enterprise: "$100k",
          "Complete Managed Service": "Base Subscription +$60K",
          "Clearsense in a Box": "Deployable containers",
        },
      },
      {
        name: "Platform Fees( Subscription Only )",
        tiers: {
          Free: true,
          Standard: true,
          Enterprise: false,
          "Complete Managed Service": false,
          "Clearsense in a Box": false,
        },
      },
      {
        name: "Structured Data Storage( Hybrid - Onpremise Storage & Azure Compute )",
        tiers: {
          Free: true,
          Standard: true,
          Enterprise: "12K + 3000 per additional 10TB",
          "Clearsense in a Box": true,
        },
      },
      {
        name: "Source to Target Connectors.",
        tiers: {
          Free: "1",
          Standard: "10",
          Enterprise: "100",
          "Complete Managed Service": "250+",
          "Clearsense in a Box": true,
        },
      },
      {
        name: "Cloud Connector Azure Only",
        tiers: {
          Free: true,
          Standard: true,
          Enterprise: "Plus: Microsoft Setup Fees",
          "Complete Managed Service": "Included",
          "Clearsense in a Box": true,
        },
      },
      {
        name: "Azure Private link",
        tiers: {
          Free: true,
          Standard: true,
          "Complete Managed Service": "Included",
          "Clearsense in a Box": true,
        },
      },
      {
        name: "Always-on enterprise grade encryption in transit and at rest",
        tiers: {
          Free: true,
          Standard: true,
          "Complete Managed Service": "Included",
          "Clearsense in a Box": true,
        },
      },
      {
        name: "Data Masking",
        tiers: {
          Free: true,
          Standard: true,
          "Complete Managed Service": "Included",
          "Clearsense in a Box": true,
        },
      },
      {
        name: "Data Tokenization",
        tiers: {
          Free: true,
          Standard: true,
          "Complete Managed Service": "Included",
          "Clearsense in a Box": true,
        },
      },
      {
        name: "Deidentification",
        tiers: {
          Free: true,
          Standard: true,
          "Complete Managed Service": "Included",
          "Clearsense in a Box": true,
        },
      },
      {
        name: "Compliance",
        tiers: {
          "Complete Managed Service": "Included",
          "Clearsense in a Box": true,
        },
      },
      {
        name: "Hippa Support",
        tiers: {
          Enterprise: "Included",
          "Complete Managed Service": "Included",
          "Clearsense in a Box": true,
        },
      },
      {
        name: "PCI Support",
        tiers: {
          Enterprise: "Included",
          "Complete Managed Service": "Included",
          "Clearsense in a Box": true,
        },
      },
      {
        name: "Hitrust",
        tiers: {
          Enterprise: "Included",
          "Complete Managed Service": "Included",
          "Clearsense in a Box": true,
        },
      },
    ],
  },
  {
    id: 2,
    features: [
      {
        name: "Clearsense LakeHouse Data Management",
        priceInfo: true,
        tiers: {
          Free: false,
          Standard: "Included",
          Enterprise: "Non Managed",
          "Complete Managed Service": "Included",
          "Clearsense in a Box": true,
        },
      },
      {
        name: "Single Cluster",
        tiers: {
          Free: true,
          Standard: true,
          Enterprise: "Included",
          "Complete Managed Service": "Included",
          "Clearsense in a Box": true,
        },
      },
      {
        name: "Multi-Cluster",
        tiers: {
          "Complete Managed Service": "Included",
          "Clearsense in a Box": true,
        },
      },
      {
        name: "Single Zone",
        tiers: {
          Free: true,
          Standard: true,
          Enterprise: "Included",
          "Complete Managed Service": "Included",
          "Clearsense in a Box": true,
        },
      },
      {
        name: "Multi Zone",
        tiers: {
          "Complete Managed Service": "Included",
          "Clearsense in a Box": true,
        },
      },
      {
        name: "Single Region",
        tiers: {
          Free: true,
          Standard: true,
          Enterprise: "Included",
          "Complete Managed Service": "Included",
          "Clearsense in a Box": true,
        },
      },
      {
        name: "Multi Region",
        tiers: {
          "Complete Managed Service": "Included",
          "Clearsense in a Box": true,
        },
      },
      {
        name: "FHIR Data Domains For Sources",
        tiers: {
          Enterprise: "Included",
          "Complete Managed Service": "Included",
          "Clearsense in a Box": true,
        },
      },
      {
        name: "FHIR Server",
        tiers: {
          Enterprise: "Included",
          "Complete Managed Service": "Included",
          "Clearsense in a Box": true,
        },
      },
      {
        name: "FHIR Standardized Private Data API Gateway",
        tiers: {
          Enterprise: "Included",
          "Complete Managed Service": "Included",
          "Clearsense in a Box": true,
        },
      },
      {
        name: "# of Data Domains",
        tiers: {
          Free: "1",
          Standard: "5",
        },
      },
    ],
  },
  {
    id: 3,
    features: [
      {
        name: "Master Data Management ( Optional )",
        priceInfo: true,
        tiers: {
          Free: "No",
          Standard: "$40K",
          Enterprise: "Optional",
          "Complete Managed Service": "Optional",
          "Clearsense in a Box": true,
        },
      },
      {
        name: "Critical Data Elements",
        tiers: {
          Free: false,
          Standard: false,
          Enterprise: false,
          "Complete Managed Service": false,
          "Clearsense in a Box": true,
        },
      },
      {
        name: "Data Lineage",
        tiers: {
          Free: false,
          Standard: false,
          Enterprise: false,
          "Complete Managed Service": false,
          "Clearsense in a Box": true,
        },
      },
      {
        name: "Data Quality Rules",
        tiers: {
          Free: false,
          Standard: false,
          Enterprise: false,
          "Complete Managed Service": false,
          "Clearsense in a Box": true,
        },
      },
      {
        name: "Record Uniqueness",
        tiers: {
          Free: false,
          Standard: false,
          Enterprise: false,
          "Complete Managed Service": false,
          "Clearsense in a Box": true,
        },
      },
      {
        name: "API Based - ICD-10 Codes , RX-Norm , & More",
        tiers: {
          Free: false,
          Standard: false,
          Enterprise: false,
          "Complete Managed Service": false,
          "Clearsense in a Box": true,
        },
      },
      {
        name: "Data Steward Management",
        tiers: {
          Free: false,
          Standard: false,
          Enterprise: false,
          "Complete Managed Service": false,
          "Clearsense in a Box": true,
        },
      },
    ],
  },
  {
    id: 4,
    features: [
      {
        name: "Data Consumption",
        priceInfo: true,
        tiers: {
          Free: "No",
          Standard: "$40K",
          Enterprise: false,
          "Complete Managed Service": false,
          "Clearsense in a Box": true,
        },
      },
      {
        name: "Visualize- Access Schemas",
        tiers: {
          Standard: "10K",
          Enterprise: "Included",
          "Complete Managed Service": "Included",
          "Clearsense in a Box": true,
        },
      },
      {
        name: "Discover- Cohort Discovery",
        tiers: {
          Standard: "10K",
          Enterprise: "Included",
          "Complete Managed Service": "Included",
          "Clearsense in a Box": true,
        },
      },
      {
        name: "AI / ML Data Modelling - Compellon- ~2500( 1500 + storage )",
        tiers: {
          Standard: "20K",
          Enterprise: "Included",
          "Complete Managed Service": "Included",
          "Clearsense in a Box": true,
        },
      },
      {
        name: "NoteBook Runtime ( Optional )",
        tiers: {
          Standard: "Plus: Compute",
          Enterprise: "7K / 100GB Limit",
          "Complete Managed Service": "20K / 300GB Limit",
          "Clearsense in a Box": true,
        },
      },
    ],
  },
  {
    id: 5,
    features: [
      {
        name: "Support",
        priceInfo: true,
        tiers: {
          Free: " ",
          Standard: " ",
          Enterprise: " ",
          "Complete Managed Service": " ",
          "Clearsense in a Box": " ",
        },
      },
      {
        name: "Basic Support ( Ticket Only with 24-48 Hr SLA )",
        tiers: {
          Free: "Yes",
          Standard: "Yes",
          Enterprise: "Included",
          "Complete Managed Service": "Included",
          "Clearsense in a Box": true,
        },
      },
      {
        name: "Premier Support 24 x 365 ( Same Day SLA )",
        tiers: {
          Standard: "Yes",
          Enterprise: "Yes",
          "Complete Managed Service": "Included",
          "Clearsense in a Box": true,
        },
      },
      {
        name: "Full End to End Management Including Infrastructure",
        tiers: {
          "Complete Managed Service": "Included",
          "Clearsense in a Box": true,
        },
      },
      {
        name: "Database failover & Business Continuity",
        tiers: {
          "Complete Managed Service": "Business Quote",
          "Clearsense in a Box": true,
        },
      },
      {
        name: "Database Replication ( If needed )",
        tiers: {
          "Complete Managed Service": "Business Quote",
          "Clearsense in a Box": true,
        },
      },
    ],
  },
];
